import React from 'react';
import PlainLanguageExplainer from './PlainLanguageExplainer';

export interface PlainLanguageLabelProps {
  termId: string;
  children?: React.ReactNode;
  /** inline: dotted underline with small icon; heading: label with trailing icon */
  variant?: 'inline' | 'heading';
}

/** Back-compat wrapper — opens image-backed explainer popover on tap/click. */
const PlainLanguageLabel: React.FC<PlainLanguageLabelProps> = (props) => (
  <PlainLanguageExplainer {...props} />
);

export default PlainLanguageLabel;
